<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-10-28 15:00:16
 * @LastEditTime: 2026-06-25 17:34:09
 * @Description: 新超限发货表单
 * @Param:
 * @FilePath: \ConcreteCloud_Mobile\src\views\salesTerminal\overApplication\overrunDeliverGoodsForm.vue
 -->


<template>
    <div class="commonApprovalFormStyles overrunDeliverGoodsForm">
        <van-nav-bar title="超限发货" left-text="" left-arrow v-if="type != 'process_message'" @click-left="onClickLeft"></van-nav-bar>
        <!-- 表单 -->
        <section class="van-pull-refresh BasicContractInfo">
            <van-form class="infoList">
                <van-field
                    label="合同编号"
                    :left-icon="require('@/assets/images/icons/icon_gy_1.png')"
                    input-align="right"
                    placeholder="请选择"
                    v-model="formData.contract_number"
                    readonly
                    clickable
                    @click="choseContract"
                ></van-field>
                <van-cell
                    title="合同类型"
                    :value="formData.contract_type_name||'请选择合同'"
                    :class="{'noValue':!formData.contract_type_name}"
                    :icon="require('@/assets/images/icons/icon_gy_3.png')"
                ></van-cell>
                <van-cell
                    title="客户名称"
                    :value="formData.client_name||'请选择合同'"
                    :class="{'noValue':!formData.client_name}"
                    :icon="require('@/assets/images/icons/icon_3.png')"
                ></van-cell>
                <van-cell
                    title="工程名称"
                    :value="formData.engineering_name||'请选择合同'"
                    :class="{'noValue':!formData.engineering_name}"
                    :icon="require('@/assets/images/icons/icon_2.png')"
                ></van-cell>
                <van-cell
                    title="所属区域"
                    :value="formData.sales_area_name||'请选择合同'"
                    :class="{'noValue':!formData.sales_area_name}"
                    :icon="require('@/assets/images/icons/icon_gy_2.png')"
                ></van-cell>
                <van-field
                    label="合同履约情况"
                    :left-icon="require('@/assets/images/icons/icon_6.png')"
                    input-align="right"
                    readonly
                    clickable
                ></van-field>
                <van-cell
                    class="trans-types"
                    title="已发方量（方）"
                    :value="formData.delivery_quantity"
                    :class="{'noValue':!formData.delivery_quantity}"
                ></van-cell>
                <van-cell
                    class="trans-types"
                    title="累计应收（元）"
                    :value="formData.sales_amount"
                    :class="{'noValue':!formData.sales_amount}"
                ></van-cell>
                <van-cell
                    class="trans-types"
                    title="按合同应回款（元）"
                    :value="formData.aggregate_receivables"
                    :class="{'noValue':!formData.aggregate_receivables}"
                ></van-cell>
                <van-cell
                    class="trans-types"
                    title="实际回款（元）"
                    :value="formData.aggregate_official_receipt"
                    :class="{'noValue':!formData.aggregate_official_receipt}"
                ></van-cell>
                <van-cell
                    class="trans-types"
                    title="应收未收（元）"
                    :value="formData.outstanding_receivable"
                    :class="{'noValue':!formData.outstanding_receivable}"
                ></van-cell>
                <van-cell
                    class="trans-types"
                    title="应收余额（万元）"
                    :value="formData.receivable_amount"
                    :class="{'noValue':!formData.receivable_amount}"
                ></van-cell>
                <van-field
                    label="经办人签字确认"
                    input-align="right"
                    placeholder="经办人签字"
                    v-model="formData.operator_signature"
                    :left-icon="require('@/assets/images/icons/icon_3.png')"
                    :readonly="isReadOnly"
                ></van-field>
                <van-field
                    rows="2"
                    autosize
                    type="textarea"
                    maxlength="300"
                    :left-icon="require('@/assets/images/icons/icon_34.png')"
                    label="应急原因说明"
                    placeholder="应急原因说明"
                    input-align="right"
                    v-model="formData.application_reason"
                    :readonly="isReadOnly"
                ></van-field>
                <van-field
                    label="申请人"
                    :left-icon="require('@/assets/images/icons/icon_3.png')"
                    input-align="right"
                    placeholder="请选择"
                    v-model="formData.application_name"
                    readonly
                    clickable
                ></van-field>
                <van-field
                    label="销售部"
                    :left-icon="require('@/assets/images/icons/icon_3.png')"
                    input-align="right"
                    v-model="deptName"
                    readonly
                    clickable
                ></van-field>
                <van-field
                    label="申请时间"
                    :left-icon="require('@/assets/images/icons/icon_gy_7.png')"
                    input-align="right"
                    placeholder="请选择"
                    v-model="formData.application_time"
                    readonly
                    clickable
                ></van-field>
                <van-field
                    label="应急方量和时间期限"
                    :left-icon="require('@/assets/images/icons/icon_6.png')"
                    input-align="right"
                    readonly
                    clickable
                ></van-field>
                <van-field class="trans-types">
                    <template #input>
                        <div class="credit-limit">
                            <span>占用个人信用额度：</span>
                            <van-radio-group v-model="formData.is_saleman" direction="horizontal" :disabled="isReadOnly">
                                <van-radio :name="true" icon-size="15px" @input="changeInput" @click="creditChange">
                                    是
                                </van-radio>
                                <van-radio :name="false" icon-size="15px" @input="changeInput" @click="creditChange">
                                    否
                                </van-radio>
                            </van-radio-group>
                        </div>
                        <div>
                            <div class="custom-row">
                                <span>应急方量:</span>
                                <input v-model="formData.overrun_despatch_amount" type="number">
                                <span>方</span>
                            </div>
                            <div class="custom-row">
                                <span>型号</span>
                                <input v-model="formData.product_num" type="text" placeholder="请输入" :disabled="isReadOnly">
                            </div>
                            <div class="custom-row">
                                <span>金额</span>
                                <input v-model="formData.overrun_despatch_money" type="text" placeholder="请选择" @blur="creditChange" :disabled="isReadOnly" required>
                                <span>万元</span>
                            </div>
                            <div class="custom-row">
                                <span>时间期限</span>
                                <input type="number" v-model="formData.overrun_despatch_day" placeholder="请输入" :disabled="isReadOnly">
                                <span>天</span>
                            </div>
                            <div>
                                注：组合选择的情况，以先到先行。
                            </div>
                        </div>
                    </template>
                </van-field>
                <van-field
                    label="累计超合同发货情况"
                    :left-icon="require('@/assets/images/icons/icon_6.png')"
                    input-align="right"
                    readonly
                    clickable
                ></van-field>
                <van-field class="trans-types">
                    <template #input>
                        <div class="custom-row">
                            截止当前时间共申请过<input v-model="formData.accumulative_excess_count" disabled>次，
                            超限：根据超限发货
                            <br>累计超发方量<input v-model="formData.accumulative_excess_quantity" disabled>方，
                            <br>累计超发金额<input v-model="formData.accumulative_excess_money" disabled>元。
                        </div>
                    </template>
                </van-field>
                <van-field
                    is-link
                    readonly
                    clickable
                    label="附件"
                    input-align="right"
                    placeholder="请上传附件"
                    :left-icon="require('@/assets/images/icons/icon_24.png')"
                    v-if="['process_message', 'process'].indexOf(type) === -1"
                    @click="toUpload"
                >
                </van-field>
                <div class="approvalComments">
                    <h3 class="iconfont iconpingjia">
                        审批意见
                    </h3>
                    <ul v-if="formData.approvalOpinionList">
                        <template v-for="(item, index) in formData.approvalOpinionList">
                            <li :key="`opinion_${index}`">
                                <div class="headPortrait iconfont icon04gerenfill"></div>
                                <div class="userInfo">
                                    <div class="userName">
                                        <h4>{{ item.signer_name }}</h4>
                                        <span>{{ item.created }}</span>
                                    </div>
                                    <p class="role">
                                        {{ item.signer_role_name }}
                                    </p>
                                    <p class="opinion">
                                        {{ item.opinion }}
                                    </p>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </van-form>
            <van-dialog
                v-model="confirmedByShow"
                title="提交确认"
                show-cancel-button
                @cancel="cancelSubmission"
                @confirm="confirmSubmission"
                class="submitPopUp"
            >
                <div class="submitPopUpContent">
                    <div class="icon">
                        <img src="@/assets/images/contractApproval/icon.png" alt="">
                    </div>
                    <div class="info linkInfo">
                        <h4>
                            下一环节：
                            <span>
                                {{ submitObj.link }}
                            </span>
                        </h4>
                        <h4>
                            审批人：
                            <span>
                                {{ submitObj.obj }}
                            </span>
                        </h4>
                        <p>是否确认提交？</p>
                    </div>
                </div>
            </van-dialog>
        </section>
        <div class="commonFormBtns btn-con" v-if="!isReadOnly">
            <van-button plain type="info" @click="handleSubmit" v-if="['process_message', 'process'].indexOf(type) < 0">
                提交
            </van-button>
            <van-button type="info" @click="handleSave(null)">
                保存
            </van-button>
        </div>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
    </div>
</template>

<script>
import util from '@/utils/util';
export default {
    beforeRouteLeave(to, from, next) {
        if (['/approvalProcess', '/overApplication'].indexOf(to.path) > -1) {
            this.$store.commit('noKeepAlive', 'overrun-deliver-goods-form');
        }
        next();
    },
    name: 'overrun-deliver-goods-form',
    components: {},
    props: {},
    data() {
        return {
            // 表单数据
            formData: {
                contract_number: '',
                contract_type: '',
                engineering_name: '',
                engineering_location: '',
                client_name: '',
                overrun_despatch_mode: ['1'],
                overrun_despatch_day: '',
                statistics_signature: '',
                operator_signature: '',
                accumulative_excess_quantity: null,
                accumulative_excess_money: null,
            },
            // 销售部，展示不保存
            deptName: '',
            // 列表数据
            listData: {},
            // 流程信息
            businessInfo: {},
            // 操作类型
            type: '',
            actionType: '',
            // 表单主键
            formKeyValue: '',
            processData: {},
            CurrentBusinessProcess: {},
            // 超限发货id
            ctsid: '',
            // 加载层
            showOverlay: false,
            // 数字键盘
            showMoneyKeyboard: false,
            showAmountKeyboard: false,
            // 个人信用额度
            radio: false,
            // 个人信用额度 不可用
            creditDisable: true,
            // 业务员id
            salesUserId: '',
            // 剩余额度
            surplus_amount: null,
            // 只读
            isReadOnly: true,
            // 确认人员弹出层状态
            confirmedByShow: false,
            submitObj: {
                link: '',
                obj: '',
            },
            newsToken: '',
        };
    },
    watch: {},
    computed: {},
    activated() {
        this.actionType = this.$route.params.actionType || this.actionType;
        if (this.type === 'new' && ['selectedProjectCallBack', 'uploadFile'].indexOf(this.actionType) === -1) {
            // 获取流程信息模板
            this.getBusinessInstance();
            // 申请人
            this.formData.application_name = this.$takeTokenParameters('Name');
            this.formData.application_id = this.$takeTokenParameters('Uid');
            this.deptName = this.$takeTokenParameters('DeptName');
            // 初始化登记时间
            this.formData.application_time = util.currentTimeFormat('yyyy-MM-dd HH:mm:ss');
        } else if (
            ['process', 'process_message', 'modify'] .indexOf(this.type) > -1
            && ['selectedProjectCallBack', 'uploadFile'].indexOf(this.actionType) === -1
        ) {
            this.showOverlay = true;
            this.getRetailDetail('hideOverlay', this.getSaleman);
        } else if (this.actionType === 'selectedProjectCallBack') {
            this.handleImplement();
            this.getSaleman();
        }
    },
    created() {
        this.type = this.type || this.$route.params.type;
        this.listData = this.$route.params.listData;
        this.newsToken = this.$route.params.thisToken;
        this.formData = this.formData || this.$route.params.formData;
        if (['new', 'modify', 'process_message'].indexOf(this.type) > -1 || this.listData?.IsCompleteControl) {
            this.isReadOnly = false;
        }
        if (this.$route.params?.isReadOnly) {
            this.isReadOnly = true;
        }
        if (['process_message', 'process'].indexOf(this.type) > -1) {
            this.ctsid = this.ctsid || this.listData.FormKeyValue;
        } else if (this.type === 'modify') {
            this.ctsid = this.ctsid || this.listData.ctsid;
        }
        if (this.formData.contract_version_id) {
            this.getSaleman();
        }
    },
    mounted() {},
    methods: {
        handleSubmit() {
            if (JSON.stringify(this.CurrentBusinessProcess) === '{}') {
                this.handleSave(this.toSubmission);
            } else {
                this.toSubmission();
            }
        },
        // 跳转到提交界面
        async toSubmission() {
            this.showOverlay = false;
            // 获取环节数据请求
            // eslint-disable-next-line max-len
            const linkData = await this.getLinkDataRequest(this.approvalData.BusinessInstanceId, this.CurrentBusinessProcess.CurrentBusinessProcessId);

            let childrenData;
            // 判断环节提交模式和审批人类别，环节提交模式=1（默认环节），审批人类别=2（角色），打开选择人员弹出层
            if (
                linkData.PhaseSubmitMode === 1
                && linkData.SubmitPhaseModel
                && linkData.SubmitPhaseModel?.ApproverType === 2
                && linkData.SubmitPhaseModel?.IsAllowEditApprover
            ) {
                this.approverRoleId = linkData.SubmitPhaseModel.ApproverRoleId.split(',');
                this.approverRoleName = linkData.SubmitPhaseModel.ApproverRoleName.split(',');
                childrenData = {
                    title: '普通提交',
                    type: 'role',
                    approverRoleId: this.approverRoleId,
                    approverRoleName: this.approverRoleName,
                    processData: this.processData,
                };

                // 判断环节提交模式和审批人类别，环节提交模式=2或者=3（指定环节、自由环节）
            } else if ([2, 3].indexOf(linkData.PhaseSubmitMode) > -1) {
                this.businessPhaseId = linkData.BusinessPhaseId;
                childrenData = {
                    title: '自由提交',
                    type: 'link',
                    processData: this.processData,
                };
            } else {
                this.submitObj.link = linkData.SubmitPhaseModel?.BusinessPhaseName;
                this.submitObj.obj = linkData.SubmitPhaseModel?.ApproverName;
                this.confirmedByShow = true;
            }

            if (childrenData) {
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'submission',
                    params: {
                        data: childrenData,
                        isNews: this.isNews,
                        backPathName: 'overApplication',
                    },
                });
            }
        },

        // 取消提交
        cancelSubmission() {
            this.$toast('已取消！');
        },

        // 确认提交
        confirmSubmission() {
            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 10,
            };
            this.submitAPI(data, '提交成功！', '/interfaceApi/basicplatform/simpleflow/processes');
        },

        // 流程提交
        async submitAPI(data, message, url) {
            this.isloading = true;
            await this.submitAPIRequest(url, data);
            this.$toast.success(message);
            this.isReadOnly = true;
            if (this.isNews !== true) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'overApplication',
                    params: {
                        isRefresh: true,
                    },
                });
                this.$router.go(-1);
            }
            this.isloading = false;
        },

        // 保存
        async handleSave(callBackFn) {
            this.showOverlay = true;
            const data = JSON.parse(JSON.stringify(this.formData));
            if ((data.contract_number || '') === '') {
                this.$toast('请先选择合同！');
                this.showOverlay = false;
                return;
            }
            if (data.overrun_despatch_mode.length > 0) {
                data.overrun_despatch_mode = data.overrun_despatch_mode.join(',');
            } else {
                data.overrun_despatch_mode = '';
            }
            const isOver = this.checkOverCredit();
            if (isOver) {
                this.showOverlay = false;
                return;
            }
            if (!this.formData.overrun_despatch_money) {
                this.$toast('应急方量金额不能为空！');
                this.showOverlay = false;
                return;
            }
            if (!this.formData.overrun_despatch_day) {
                this.$toast('时间期限不能为空！');
                this.showOverlay = false;
                return;
            }
            if (this.type === 'new') {
                const res = await this.handleSave_new_Request(data);
                if (res) {
                    this.ctsid = res;
                    if (this.formData.is_saleman === true) {
                        this.modifySalemanApi();
                    }
                    this.getRetailDetail();
                    this.startBusinessInstance(callBackFn, data);
                    this.formKeyValue = res;
                    this.type = 'modify';
                    this.$toast('保存成功！');
                    if (!callBackFn) {
                        this.showOverlay = false;
                    }
                }
                setTimeout(() => {
                    this.showOverlay = false;
                }, 2000);
            } else {
                const res = await this.handleSave_Request(data);
                if (res) {
                    this.$toast('修改成功！');
                    this.getCurrentProcess(callBackFn);
                    if (!callBackFn) {
                        this.showOverlay = false;
                    }
                }
                setTimeout(() => {
                    this.showOverlay = false;
                }, 2000);
            }
        },
        // 拉取业务员
        async getSaleman() {
            const res = await this.getSalemanApi();
            if (res) {
                this.salesUserId = res;
                const creditLimit = await this.getUserCreditLimit();
                if (creditLimit) {
                    this.surplus_amount = creditLimit.surplus_amount;
                }
            }
        },
        // 拉取合同执行信息
        async handleImplement() {
            const res = await this.getImplement();
            if (res) {
                this.formData = Object.assign(this.formData, res);
                this.$forceUpdate();
            }
        },
        // 个人额度 是否
        creditChange() {
            if (this.formData.is_saleman === true && this.formData.overrun_despatch_money && this.formData.overrun_despatch_money > 0) {
                if (!this.surplus_amount) {
                    this.formData.is_saleman = false;
                    this.$toast('该合同业务员未分配信用额度！');
                } else if (Number(this.formData.overrun_despatch_money) > Number(this.surplus_amount) / 10000) {
                    this.formData.overrun_despatch_money = Number(this.surplus_amount) / 10000 + '';
                    this.$toast('已超该合同业务员信用额度【' + Number(this.surplus_amount) / 10000 + '万元】已为您重置!');
                }
                this.$forceUpdate();
            }
        },
        changeInput() {
            this.$forceUpdate();
        },
        // 判断是否超额
        checkOverCredit() {
            let b = false;
            if (this.formData.is_saleman === true && this.formData.overrun_despatch_money && this.formData.overrun_despatch_money > 0) {
                if (!this.surplus_amount) {
                    this.formData.is_saleman = false;
                    this.$toast('该合同业务员未分配信用额度！');
                } else if (Number(this.formData.overrun_despatch_money) > Number(this.surplus_amount) / 10000) {
                    this.formData.overrun_despatch_money = Number(this.surplus_amount) / 10000 + '';
                    this.$toast('已超该合同业务员信用额度【' + Number(this.surplus_amount) / 10000 + '万元】已为您重置!');
                    b = true;
                }
                this.$forceUpdate();
            }
            return b;
        },
        overrunMoneyBlur() {
            this.showMoneyKeyboard = false;
            this.checkOverCredit();
        },
        // 启动流程实例
        async startBusinessInstance(callBackFn, row) {
            this.showOverlay = true;
            const data = {
                BusinessInstanceId: this.businessInfo.BusinessInstanceId,
                ConfigBusinessId: this.businessInfo.ConfigBusiness.BusinessId,
                BusinessCode: this.businessInfo.ConfigBusiness.BusinessCode,
                BusinessName: this.businessInfo.ConfigBusiness.BusinessName,
            };
            const res = await this.startBusinessInstanceRequest(data);
            if (res) {
                this.saveFrom(callBackFn);
            }
            this.updateConfiguration(row);
        },
        // 记录保存过的表单数据
        async saveFrom(callBackFn) {
            const data = {
                BusinessInstanceId: this.businessInfo.BusinessInstanceId,
                BusinessPhaseId: '',
                FormId: this.businessInfo.BusinessFormList[0].FormId,
                FormName: this.businessInfo.BusinessFormList[0].FormName,
                FormUrl: this.businessInfo.BusinessFormList[0].FormUrl,
                FormKeyName: this.businessInfo.BusinessFormList[0].FormKeyName,
                FormKeyValue: this.formKeyValue,
            };
            await this.saveFromRequest(data);
            this.getCurrentProcess(callBackFn);
        },

        // 超发流程配置-业务员
        updateConfiguration(row) {
            return this.$axios.$post('/interfaceApi/sale/contract_transfinite/processes_excludephase', row, { defEx: true });
        },

        // 根据环节获取流程实例信息
        async getProcessData(callBackFn) {
            const res = await this.getProcessDataRequest();
            // 流程数据
            this.processData = res;
            // 当前流程环节信息
            this.CurrentBusinessProcess = res.CurrentBusinessProcess;
            if (callBackFn) {
                callBackFn();
            }
        },
        // 获取当前流程环节
        async getCurrentProcess(callBackFn) {
            const res = await this.getCurrentProcessRequest();
            if (res) {
                this.approvalData = res;
                this.getProcessData(callBackFn);
            }
        },
        // 超发方式
        checkboxChange(names) {
            const arr = names.filter(item => item === '1');
            if (arr.length > 0) {
                this.creditDisable = false;
            } else {
                this.creditDisable = true;
                this.formData.is_saleman = null;
            }
        },
        // 返回的时间格式化
        formatDate(date) {
            let month = date.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }
            let day = date.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            let Hours = date.getHours();
            if (Hours < 10) {
                Hours = '0' + Hours;
            }
            let Minutes = date.getMinutes();
            if (Minutes < 10) {
                Minutes = '0' + Minutes;
            }
            let Seconds = date.getSeconds();
            if (Seconds < 10) {
                Seconds = '0' + Seconds;
            }
            return `${date.getFullYear()}-${month}-${day} ${Hours}:${Minutes}:${Seconds}`;
        },
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            // this.$router.replace({ name: 'overApplication' });
            this.$router.go(-1);
        },
        // 选择合同
        choseContract() {
            if (['process_message', 'process'].indexOf(this.type) > -1 || this.isReadOnly) {return;}
            this.$router.isBack = 2;
            this.$router.push({
                name: 'overContractList',
                params: {
                    formData: this.formData,
                    pageName: 'overrunDeliverGoodsForm',
                },
            });
        },
        // 上传附件
        toUpload() {
            if (['process_message', 'process'].indexOf(this.type) > -1) {return;}
            let BusinessInstanceId = '';
            if (this.type === 'new') {
                BusinessInstanceId = this.businessInfo.BusinessInstanceId;
            } else {
                BusinessInstanceId = this.formData.business_instance_id;
            }
            if (BusinessInstanceId) {
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'fileUpload',
                    params: {
                        isView: this.isReadOnly,
                        formData: this.formData,
                        BusinessInstanceId: BusinessInstanceId,
                        type: this.type,
                        fromPath: 'newOverApplication',
                        title: '附件上传',
                    },
                });
            } else {
                this.$toast('请先保存表单数据！');
            }

        },
        // 获取流程模板信息
        async getBusinessInstance() {
            const res = await this.getBusinessInstanceRequest();
            if (res) {
                this.businessInfo = res;
                this.formData.business_instance_id = this.businessInfo.BusinessInstanceId;
            }
        },

        // 获取超发申请详情
        async getRetailDetail(hideOverlay, callFn) {
            const res = await this.getRetailDetailRequest();
            if (res) {
                if (!res.overrun_despatch_money) {
                    res.overrun_despatch_money = '';
                }
                if (!res.overrun_despatch_amount) {
                    res.overrun_despatch_amount = '';
                }
                res.overrun_despatch_money = res.overrun_despatch_money + '';
                res.overrun_despatch_amount = res.overrun_despatch_amount + '';
                if ((res.overrun_despatch_mode || []).indexOf(',') === -1) {
                    res.overrun_despatch_mode = [res.overrun_despatch_mode];
                } else {
                    res.overrun_despatch_mode = res.overrun_despatch_mode.split(',');
                }
                this.formData = res;
                if (hideOverlay) {
                    this.showOverlay = false;
                }
                if (callFn) {
                    callFn();
                }
            }
            this.showOverlay = false;
        },
        // 修改信誉额度
        modifySalemanApi() {
            const path = '/interfaceApi/sale/contract_transfinite/modify_saleman_guarantee/' + this.ctsid;
            return this.$axios.$post(path, { defEx: true, token: this.newsToken });
        },
        // 获取信用额度
        getUserCreditLimit() {
            let path = '';
            if (this.ctsid) {
                path = '/interfaceApi/sale/guarantee_manager/get_user?userId=' + this.salesUserId + '&key_id=' + this.ctsid;
            } else {
                path = '/interfaceApi/sale/guarantee_manager/get_user?userId=' + this.salesUserId;
            }
            return this.$axios.$get(path, { defEx: true, token: this.newsToken });
        },
        // 根据合同版本Id拉取业务员
        getSalemanApi() {
            const path = '/interfaceApi/sale/contract_manager/get_saleman/' + this.formData.contract_version_id;
            return this.$axios.$get(path, { defEx: true, token: this.newsToken });
        },
        // 拉取合同执行信息
        getImplement() {
            const path = '/interfaceApi/sale/contract_transfinite/init_contract_transfinite?contract_number=' + this.formData.contract_number;
            return this.$axios.$get(path, { defEx: true, token: this.newsToken });
        },

        // 流程提交请求
        submitAPIRequest(url, data) {
            return this.$axios.$post(url, data, { defEx: true, token: this.newsToken });
        },
        // 启动流程实例请求
        startBusinessInstanceRequest(data) {
            return this.$axios.$post('/interfaceApi/basicplatform/simpleflow/businessinstance', data, { defEx: true, token: this.newsToken });
        },
        // 记录保存过的表单数据请求
        saveFromRequest(data) {
            // eslint-disable-next-line max-len
            return this.$axios.$post('/interfaceApi/basicplatform/simpleflow/businessinstance/businessform', data, { defEx: true, token: this.newsToken });
        },
        // 根据环节获取流程实例信息请求
        getProcessDataRequest() {
            // eslint-disable-next-line max-len
            const url = `/interfaceApi/basicplatform/simpleflow/processes/${this.approvalData.BusinessInstanceId}/${this.approvalData.BusinessProcessId}`;
            return this.$axios.$get(url, { defEx: true, token: this.newsToken });
        },
        // 获取当前流程环节请求
        getCurrentProcessRequest() {
            const url = `/interfaceApi/basicplatform/simpleflow/processes/transaction_model/${this.formData.business_instance_id}`;
            return this.$axios.$get(url, { defEx: true, token: this.newsToken });
        },
        // 获取流程模板信息请求
        getBusinessInstanceRequest() {
            // eslint-disable-next-line max-len
            return this.$axios.$get('/interfaceApi/basicplatform/simpleflow/businessinstance/templateinfo/HTPS-CXFH', { defEx: true, token: this.newsToken });
        },
        // 获取超发申请详情请求
        getRetailDetailRequest() {
            if (!this.ctsid) { return false;}
            // eslint-disable-next-line max-len
            return this.$axios.$get(`/interfaceApi/sale/contract_transfinite/get_retail_detail/${this.ctsid}`, { defEx: false, token: this.newsToken });
        },
        // 保存请求
        handleSave_Request(data) {
            return this.$axios.$put('/interfaceApi/sale/contract_transfinite/modify_retail', data, { defEx: true, token: this.newsToken });
        },
        // 新增保存请求
        handleSave_new_Request(data) {
            return this.$axios.$post('/interfaceApi/sale/contract_transfinite/add_retail', data, { defEx: true, token: this.newsToken });
        },

        // 获取环节数据请求
        getLinkDataRequest(businessInstanceId, businessPhaseId) {
            const path = `/interfaceApi/basicplatform/simpleflow/processes/getcurrentbusinessprocess/${businessInstanceId}/${businessPhaseId}`;
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.overrunDeliverGoodsForm
    .van-pull-refresh
        height calc(100% - 45rpx)
        overflow-y auto
        padding-bottom 60rpx
        .van-form
            .trans-types
                padding-left 30rpx
                .van-field__control--custom
                    display block
                .custom-row
                    margin-bottom 10rpx
                    input
                        width 100rpx
                        border 0
                        border-bottom 1px solid #ccc
                        margin 0 6rpx
                        text-align center
                        border-radius 0
                .credit-limit
                    margin 10rpx 0
                    display flex
                    span
                        margin-right 15rpx
                .checkbox-con
                    margin 6rpx 0 10rpx 0
                .tooltip
                    font-size 12rpx
                    .red
                        color #E50000
                    p
                        text-indent 1rem
            .van-cell__title
                span
                    white-space nowrap
            .van-cell__value
                color #323233
            .noValue
                .van-cell__value
                    color #969799
        .submitPopUp
            .van-dialog__header
                padding-top 0
                line-height 50rpx
            .van-dialog__content
                padding 15rpx 0
                border-top 2px solid #F0F0F0
                text-align center
                .icon, .info
                    display inline-block
                    vertical-align top
                .icon
                    width 94rpx
                    height 84rpx
                    img
                        height 100%
                .info
                    text-align left
                    margin-top 10rpx
                    h4
                        line-height 20rpx
                        font-size 14rpx
                        color #666666
                        margin-bottom 20rpx
                        span
                            font-size 18rpx
                            color #3495FB
                    p
                        font-size 14rpx
                        color #979EA7
                    &.linkInfo
                        margin-top 5rpx
                        h4
                            margin-bottom 10rpx
        .approvalComments
            padding 10rpx 15rpx
            h3
                font-size 18rpx
                line-height 28rpx
                color #3495FB
            ul
                li
                    padding-top 10rpx
                    border-bottom 1px dashed #D7D7D7
                    display flex
                    &:last-child
                        border-bottom none
                    .headPortrait
                        width 36rpx
                        height 36rpx
                        border 1px solid #ADCDE4
                        background #ADCDE4
                        font-size 20rpx
                        line-height 36rpx
                        text-align center
                        border-radius 50%
                        color #fff
                        margin-right 10rpx
                    .userInfo
                        width calc(100% - 46rpx)
                        .userName
                            display flex
                            justify-content space-between
                            line-height 24rpx
                            h4
                                font-size 16rpx
                                color #333333
                            span
                                font-size 12rpx
                                color #979EA7
                        .role
                            font-size 12rpx
                            color #979EA7
                            margin-bottom 5rpx
                        .opinion
                            font-size 14rpx
                            line-height 22rpx
                            color #666666
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
    .btn-con
        position fixed
        width 100%
        bottom 0
        z-index 0
</style>
